module.exports = __webpack_public_path__ + "img/leamos_im_auto.a0d71e27.jpg";